import { render, staticRenderFns } from "./All_SetNewPassword.vue?vue&type=template&id=06a0ac1a&scoped=true&"
import script from "./All_SetNewPassword.vue?vue&type=script&lang=js&"
export * from "./All_SetNewPassword.vue?vue&type=script&lang=js&"
import style0 from "./All_SetNewPassword.vue?vue&type=style&index=0&id=06a0ac1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a0ac1a",
  null
  
)

export default component.exports